<template>
  <common-dialog
    ref="dialog"
    width="500px"
    title="流程基本设置"
    :data="data"
    @create-opened="onCreateOpened"
    @edit-opened="onEditOpened"
    :form-rules="rules"
    @closed="onClosed"
  >
    <template slot="form">
      <el-form-item label="流程类别" prop="CopyId">
        <template-select v-model="data.CopyId" @select="x=>data.ProcessName=x.ProcessName" />
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="onNext">下一步</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import templateSelect from "./select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    templateSelect,
  },
  computed: {},
  data() {
    return {
      api: require("@/api/wf/process").default,
      Process: [],
      data: {
        ProcessId: "00000000-0000-0000-0000-000000000000",
        ProcessName: "",
        CopyId: null,
      },
      isNext: false,
      saveData: null,
      rules: {
        CopyId: [{ required: true, message: "流程类别不能为空" }],
        // EmpId: [{ required: true, message: "请选择异常处理人员" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
      this.isEdit = false;
    },
    onEditOpened(data) {
      this.isEdit = true;
    },
    onNext() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        this.isNext = true;
        this.saveData = { ...this.data };
        this.close(true);
      });
    },
    onClosed() {
      if (this.isNext) {
        this.$emit("on-next", this.saveData);
        this.isNext = false;
      }
    },
  },
};
</script>
<style lang="scss">
</style>